<template>
  <div class="about">
    <div class="instructions">
    <!-- <h1>Poppa Lock</h1> -->
    <h1>How to Play</h1>
    <p>When the red rectangle is overlapping with the yellow circle</p>
    <p>press space bar, click your mouse, or tap your screen.</p>
    <p>After each successful round, the red rectangle will increase in speed.</p>
    <br>
    <h1>Credits</h1>
    <p>This is a web game made with Vue.js, Airtable, and Netlify.</p>
    <p>Font family is IBM Plex Mono. Mo.js is used for the burst animation.</p>
    <p>Shout out to Codepen.io for inspiration.</p>
    <p>Last updated in March 2021</p>
    <br>
    <Footer />
    </div>
  </div>
</template>

<script>
import Footer from '../components/Footer'
export default {
  components: {
    Footer
  },
  created() {
    document.body.style.overflow = 'visible';
  },
}
</script>

<style lang="scss" scoped>
  .about {
    color: white;

    h1 {
      margin-top: 2rem;
      font-weight: bold;
    }

    .instructions {
      text-align: left;
      max-width: 30rem;
      text-justify: inter-word;
      margin: auto;
      padding: 0 2rem;
    }
  }
</style>
